// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-publisher-preview-preview-page-wrapper-component-js": () => import("./../../../src/publisher-preview/PreviewPageWrapperComponent.js" /* webpackChunkName: "component---src-publisher-preview-preview-page-wrapper-component-js" */)
}

